import type { IValues } from '../../containers/NewLocation/valuesTypes';

import InputMask from 'react-input-mask';

import { Field, ErrorMessage, useFormikContext } from 'formik';

import { useTranslation } from 'react-i18next';


export const TestSiteRepresentativeInformation = () => {
    const { t} = useTranslation();
    const { values, handleChange, handleBlur, errors, setFieldTouched, setFieldValue, touched } = useFormikContext<IValues>();


    return (
        <div className="cco_form_row">
            <div className="cco_form_col">
                <h2 className="cco_form_heading"><strong>5. {t("NewLocation.Representation.representativeInformation")} </strong> </h2>

                <p className="cco_form_subheading">
                    {t("NewLocation.Representation.testingFacility")}
                </p>

                <div className="cco_form_wrap">
                    <ul className="cco_form_fieldset">
                        <li className="cco_form_fieldset_item cco_form_fieldset_item_medium">
                            <label htmlFor="ccoFullNameTSR">{t("NewLocation.Representation.name")} <span style={{ color: '#db3a3a' }}>*</span></label>

                            <Field type="text" id="ccoFullNameTSR" name="fullName" />
                            <ErrorMessage component={'div'} name={'fullName'} className="cco_form_message cco_form_message_error" />
                        </li>

                        <li className="cco_form_fieldset_item cco_form_fieldset_item_medium">
                            <label htmlFor="ccoPhoneTSR">{t("NewLocation.Representation.phone")}<span style={{ color: '#db3a3a' }}>*</span></label>

                            <InputMask
                                type={'tel'}
                                id={'ccoPhoneTSR'}
                                mask="+1 (999) 999-9999"
                                value={values.phoneNumber}
                                onChange={handleChange('phoneNumber')}
                                onBlur={handleBlur('phoneNumber')}
                            />

                            <ErrorMessage component={'div'} name={'phoneNumber'} className="cco_form_message cco_form_message_error" />
                        </li>

                        <li className="cco_form_fieldset_item cco_form_fieldset_item_medium">
                            <label htmlFor="ccoEmailTSR">{t("NewLocation.Representation.email")} <span style={{ color: '#db3a3a' }}>*</span></label>

                            <Field type="email" id="ccoEmailTSR" name="email" />
                            <ErrorMessage name={'email'} component={'div'} className="cco_form_message cco_form_message_error" />
                        </li>

                        <li className="cco_form_fieldset_item cco_form_fieldset_item_medium">
                            <label htmlFor="ccoEmailConfirmationTSR">{t("NewLocation.Representation.emailconfirmation")} <span style={{ color: '#db3a3a' }}>*</span></label>

                            <Field type="email" id="ccoEmailConfirmationTSR" name="emailConfirmation" />
                            <ErrorMessage component={'div'} name={'emailConfirmation'} className="cco_form_message cco_form_message_error" />
                        </li>

                        <li className="cco_form_fieldset_item cco_form_fieldset_item_large">
                            <label htmlFor="ccoTCTSR">
                                {t("NewLocation.Representation.uploadtsragreement")} <small>{t("NewLocation.Representation.maxsizemb")} </small><span style={{ color: '#db3a3a' }}>*</span>
                            </label>

                            <div className="cco_form_field cco_form_field_0">
                                <div className="cco_form_field_body">
                                    <label className="cco_form_field_label ccs_loader_relative_container" htmlFor="ccoTCTSR">
                                        {(values.termsAndConditions instanceof File && values.termsAndConditions.type.includes('image')) ||
                                        ('string' === typeof values.termsAndConditions &&
                                            values.termsAndConditions &&
                                            !values.termsAndConditions.includes('.pdf')) ? (
                                            <>
                                                <img
                                                    src={
                                                        values.termsAndConditions instanceof File
                                                            ? URL.createObjectURL(values.termsAndConditions)
                                                            : values.termsAndConditions
                                                    }
                                                    onLoad={e => {
                                                        const src = e.currentTarget.src;

                                                        if (src.startsWith('blob:')) URL.revokeObjectURL(src);
                                                    }}
                                                    alt="user profile picture"
                                                />
                                                <span className="cco_form_field_label_caption cco_form_field_label_caption_hover">{t("NewLocation.Representation.upload")}</span>
                                            </>
                                        ) : (
                                            <>
                                                <span className="cco_form_field_label_icon cco_form_field_label_icon_file"></span>
                                                <span className="cco_form_field_label_caption">{t("NewLocation.Representation.upload")}</span>
                                            </>
                                        )}
                                    </label>

                                    <Field
                                        type={'file'}
                                        id={'ccoTCTSR'}
                                        accept={'.pdf'}
                                        value={undefined}
                                        name={'termsAndConditions'}
                                        className={'cco_form_field_input'}
                                        onChange={(event: any) => {
                                            if (!event.currentTarget.files[0]) {
                                                return;
                                            }

                                            setFieldTouched('termsAndConditions', true);
                                            setFieldValue('termsAndConditions', event.currentTarget.files[0], true);
                                        }}
                                    />
                                </div>

                                <div className="cco_form_field_aside">
                                    {values.termsAndConditions && !errors.termsAndConditions && touched.termsAndConditions && (
                                        <div className="cco_form_message cco_form_message_has_icon cco_form_message_success">
                                            {values.termsAndConditions instanceof File ? values.termsAndConditions.name : null /* values.termsAndConditions */}
                                        </div>
                                    )}

                                    <ErrorMessage
                                        name={'termsAndConditions'}
                                        component={'div'}
                                        className="cco_form_message cco_form_message_has_icon cco_form_message_error"
                                    />
                                </div>
                            </div>

                            <div className="cco_form_btn cco_form_btn_2">
                                <a href="https://www.nccco.org/EOTtsra" target="_blank">
                                {t("NewLocation.Representation.downloadagreement")}
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
